import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';
import { isDesktop, notMobile } from '@zola-helpers/client/dist/es/util/responsive';

import useForceUpdateOnWindowResize from '../../../../lib/hooks/useForceUpdateOnWindowResize';

const ManageWebsiteActions = ({ slug, published, pageKey, publishWebsite }) => {
  useForceUpdateOnWindowResize();
  return (
    <div className="manage-website-actions__container">
      {!published && (
        <ul className="manage-website-actions__list">
          <li>
            <ButtonV2
              component="a"
              href={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`}
              variant="secondary"
              className="preview-website__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {notMobile() ? 'Preview ' : ''}Website
            </ButtonV2>
          </li>
          <li>
            <ButtonV2
              className="make-website-visible__btn"
              variant="tertiary"
              onClick={publishWebsite}
            >
              Make Website Visible
            </ButtonV2>
          </li>
        </ul>
      )}
      {published && (
        <ul className="manage-website-actions__list">
          <li className="manage-website-actions__settings">
            <ButtonV2
              component="a"
              href="/account/settings/privacy"
              variant="secondary"
              className="navbar-btn view-settings__btn"
            >
              {isDesktop() ? 'View ' : ''}Settings
            </ButtonV2>
          </li>
          <li className="manage-website-actions__settings">
            <ButtonV2
              component="a"
              href={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`}
              className="navbar-btn view-website__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Website
            </ButtonV2>
          </li>
        </ul>
      )}
    </div>
  );
};

ManageWebsiteActions.propTypes = {
  slug: PropTypes.string,
  published: PropTypes.bool,
  publishWebsite: PropTypes.func,
  pageKey: PropTypes.string,
};

export default ManageWebsiteActions;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/ManageWebsiteActions.jsx